import { render, staticRenderFns } from "./Atime.vue?vue&type=template&id=38f95ac9&scoped=true"
import script from "./Atime.vue?vue&type=script&lang=js"
export * from "./Atime.vue?vue&type=script&lang=js"
import style0 from "./Atime.vue?vue&type=style&index=0&id=38f95ac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f95ac9",
  null
  
)

export default component.exports